import { render, staticRenderFns } from "./EditProduct.vue?vue&type=template&id=8f8e7d54&scoped=true"
import script from "./EditProduct.vue?vue&type=script&lang=js"
export * from "./EditProduct.vue?vue&type=script&lang=js"
import style0 from "./EditProduct.vue?vue&type=style&index=0&id=8f8e7d54&prod&lang=css"
import style1 from "./EditProduct.vue?vue&type=style&index=1&id=8f8e7d54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8e7d54",
  null
  
)

export default component.exports